import type { CSSProperties } from 'react'

export const btnShimmerCss = `
  @keyframes _btn_shimmer {
    0%   { transform: translateX(-150%) skewX(-15deg); }
    100% { transform: translateX(350%)  skewX(-15deg); }
  }
`

export const btnShimmerOverlayStyle: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  borderRadius: 'inherit',
  background: 'linear-gradient(90deg, transparent 20%, rgba(255,255,255,0.35) 50%, transparent 80%)',
  animation: '_btn_shimmer 1.4s ease-in-out infinite',
}
